export function toWaDigits(raw: string | null | undefined): string {
  return (raw ?? "").replace(/\D/g, "").replace(/^0+/, "");
}

export function toWhatsAppLink(rawPhone: string | null | undefined, message: string): string {
  const phoneDigits = toWaDigits(rawPhone);
  return phoneDigits ? `https://wa.me/${phoneDigits}?text=${encodeURIComponent(message)}` : "";
}

export function toWhatsAppShareLink(message: string): string {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
